import { ADD_CRUSH_FAIL, ADD_CRUSH_REQUEST, ADD_CRUSH_SUCCESS, REMOVE_CRUSH_FAIL, REMOVE_CRUSH_REQUEST, REMOVE_CRUSH_SUCCESS } from "../types";

export const CrushAddReducer = (
  state = { error: null, crushes: [] },
  action
) => {
  switch (action.type) {
    case ADD_CRUSH_REQUEST:
      return { ...state, loading: true };
    case ADD_CRUSH_SUCCESS:
      return { ...state, loading: false, crush: action.payload };
    case ADD_CRUSH_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};


export const CrushRemoveReducer = (
  state = { error: null },
  action
) => {
  switch (action.type) {
    case REMOVE_CRUSH_REQUEST:
      return { ...state, loading: true };
    case REMOVE_CRUSH_SUCCESS:
      return { ...state, loading: false,  success: true};
    case REMOVE_CRUSH_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
